export const reducerName = "router" as const

export const createRouterActionName = (actionName: string): string =>
    `${reducerName}/${actionName}`

export const LOCATION_CHANGE = createRouterActionName("LOCATION_CHANGE")
